import { TranslateService } from '@ngx-translate/core';

import { IProductType } from '@cakeiteasy/web-utils';

import { getDeliveryAvailability, getPickupAvailability } from './index';

function isThirdPartyWebshopAvailable(productType: IProductType): boolean {
  const {
    bakery: {
      thirdPartyDeliveryEnabled,
      thirdPartyDeliveryAllowedOnWebshop,
    }
  } = productType;

  return thirdPartyDeliveryEnabled && thirdPartyDeliveryAllowedOnWebshop;
}

function formatLeadTime(translate: TranslateService, minutesCount = 0): string {
  const hours = Math.trunc(minutesCount / 60);
  const minutes = minutesCount % 60;
  const parts = [];

  if (hours) {
    parts.push(`${ hours } ${ translate.instant('common.timing.hoursAbbr') }`);
  }

  if (minutes) {
    parts.push(`${ minutes } ${ translate.instant('common.timing.minutesAbbr') }`);
  }

  return parts.length
    ? parts.join(' ')
    : `0 ${ translate.instant('common.timing.minutesAbbr') }`;
}

export function getSameDayDeadlineMessage(translate: TranslateService, productType: IProductType): string | null {
  const { sameDayDeliverySettings: sameDaySettings } = productType;

  if (!sameDaySettings) {
    return null;
  }

  const {
    isAvailableForSameDayDelivery,
    isAvailableForSameDayDeliveryToDoor,
    minPickupLeadTimeMinutes,
    minDeliveryLeadTimeMinutes,
  } = sameDaySettings;

  const isPickupAvailable = isAvailableForSameDayDelivery && getPickupAvailability(productType);
  const isDeliveryAvailable = isAvailableForSameDayDeliveryToDoor
    && (getDeliveryAvailability(productType) || isThirdPartyWebshopAvailable(productType));

  if (isPickupAvailable && isDeliveryAvailable) {
    return translate.instant('cakeBuilder.productInfo.sameDayDeadlinePickupAndDelivery', {
      pickupLeadTime: formatLeadTime(translate, minPickupLeadTimeMinutes),
      deliveryLeadTime: formatLeadTime(translate, minDeliveryLeadTimeMinutes),
    });
  }

  if (isPickupAvailable) {
    return translate.instant('cakeBuilder.productInfo.sameDayDeadlinePickupOnly', {
      pickupLeadTime: formatLeadTime(translate, minPickupLeadTimeMinutes),
    });
  }

  if (isDeliveryAvailable) {
    return translate.instant('cakeBuilder.productInfo.sameDayDeadlineDeliveryOnly', {
      deliveryLeadTime: formatLeadTime(translate, minDeliveryLeadTimeMinutes),
    });
  }

  return null;
}
